import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calculator, ChevronDown, BookOpen, Newspaper, Info } from 'lucide-react';
import BurgerMenu from './BurgerMenu';

const categories = [
  { name: 'Customer Acquisition', path: '/customer-acquisition' },
  { name: 'Customer Retention and Value', path: '/customer-retention-value' },
  { name: 'Engagement and Interaction', path: '/engagement-interaction' },
  { name: 'Email Marketing Performance', path: '/email-marketing-performance' },
  { name: 'Web and Content Analysis', path: '/web-content-analysis' },
  { name: 'Advertising and Media Performance', path: '/advertising-media-performance' },
  { name: 'Social Media and Influencers', path: '/social-media-influencers' },
  { name: 'Growth and Market Share', path: '/growth-market-share' },
];

const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <Calculator className="w-8 h-8 text-indigo-600 mr-2" />
            <span className="text-xl font-bold text-gray-800">MarketCalc</span>
          </Link>
          <nav className="hidden md:block">
            <ul className="flex space-x-6 items-center">
              <li><Link to="/" className="text-gray-600 hover:text-indigo-600">Home</Link></li>
              <li className="relative">
                <button
                  className="text-gray-600 hover:text-indigo-600 flex items-center"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  Calculators
                  <ChevronDown className="w-4 h-4 ml-1" />
                </button>
                {isDropdownOpen && (
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
                    <ul className="py-2">
                      {categories.map((category, index) => (
                        <li key={index}>
                          <Link
                            to={category.path}
                            className="block px-4 py-2 text-sm text-gray-700 hover:bg-indigo-50 hover:text-indigo-600"
                            onClick={() => setIsDropdownOpen(false)}
                          >
                            {category.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-indigo-600 flex items-center">
                  <Newspaper className="w-5 h-5 mr-1" />
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/glossary" className="text-gray-600 hover:text-indigo-600 flex items-center">
                  <BookOpen className="w-5 h-5 mr-1" />
                  Glossary
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-600 hover:text-indigo-600 flex items-center">
                  <Info className="w-5 h-5 mr-1" />
                  About
                </Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Navigation */}
          <BurgerMenu categories={categories} />
        </div>
      </div>
    </header>
  );
};

export default Header;
